"use strict";

var _classCallCheck = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MinHeap = void 0;

var node_1 = require("./node");

var MinHeap = /*#__PURE__*/function () {
  function MinHeap(heap) {
    _classCallCheck(this, MinHeap);

    this._nodes = [];

    if (heap) {
      this._insertAll(heap);
    }
  }

  _createClass(MinHeap, [{
    key: "push",
    value: function push(key, value) {
      var node = new node_1.Node(key, value);

      this._nodes.push(node);

      this._moveUp(this._nodes.length - 1);
    }
  }, {
    key: "pop",
    value: function pop() {
      if (this.count <= 0) {
        return undefined;
      }

      if (this.count === 1) {
        var node = this._nodes[0];
        this.clear();
        return node;
      }

      var rootNode = this._nodes[0];
      this._nodes[0] = this._nodes.pop();

      this._moveDown(0);

      return rootNode;
    }
  }, {
    key: "peek",
    value: function peek() {
      if (this._nodes.length <= 0) {
        return undefined;
      }

      return this._nodes[0];
    }
  }, {
    key: "clone",
    value: function clone() {
      return new MinHeap(this);
    }
  }, {
    key: "clear",
    value: function clear() {
      this._nodes = [];
    }
  }, {
    key: "_moveUp",
    value: function _moveUp(originalIndex) {
      var index = originalIndex;
      var node = this._nodes[index];

      while (index > 0) {
        var parentIndex = this._parentIndex(index);

        if (this._nodes[parentIndex].key > node.key) {
          this._nodes[index] = this._nodes[parentIndex];
          index = parentIndex;
          continue;
        }

        break;
      }

      this._nodes[index] = node;
    }
  }, {
    key: "_moveDown",
    value: function _moveDown(originalIndex) {
      var index = originalIndex;
      var node = this._nodes[index];
      var halfCount = this.count >> 1;

      while (index < halfCount) {
        var leftChild = this._leftChildIndex(index);

        var rightChild = this._rightChildIndex(index);

        var nextPath = rightChild < this.count && this._nodes[rightChild].key < this._nodes[leftChild].key ? rightChild : leftChild;

        if (this._nodes[nextPath].key > node.key) {
          break;
        }

        this._nodes[index] = this._nodes[nextPath];
        index = nextPath;
      }

      this._nodes[index] = node;
    }
  }, {
    key: "_parentIndex",
    value: function _parentIndex(index) {
      return index - 1 >> 1;
    }
  }, {
    key: "_leftChildIndex",
    value: function _leftChildIndex(index) {
      return index * 2 + 1;
    }
  }, {
    key: "_rightChildIndex",
    value: function _rightChildIndex(index) {
      return index * 2 + 2;
    }
  }, {
    key: "_insertAll",
    value: function _insertAll(heap) {
      if (!(heap instanceof MinHeap)) {
        throw new Error('Only heap instance can be inserted');
      }

      this._insertAllFromHeap(heap);
    }
  }, {
    key: "_insertAllFromHeap",
    value: function _insertAllFromHeap(heap) {
      var keys = heap.keys,
          values = heap.values;

      if (this.count <= 0) {
        for (var i = 0; i < heap.count; i += 1) {
          this._nodes.push(new node_1.Node(keys[i], values[i]));
        }

        return;
      }

      for (var _i = 0; _i < heap.count; _i += 1) {
        this.push(keys[_i], values[_i]);
      }
    }
  }, {
    key: "count",
    get: function get() {
      return this._nodes.length;
    }
  }, {
    key: "keys",
    get: function get() {
      return this._nodes.map(function (n) {
        return n.key;
      });
    }
  }, {
    key: "values",
    get: function get() {
      return this._nodes.map(function (n) {
        return n.value;
      });
    }
  }]);

  return MinHeap;
}();

exports.MinHeap = MinHeap;